import React from 'react';
import AddEpisode from '../components/AddEpisode/AddEpisode';

const Episode = () => {
	return (
		<div className="container" style={{ top: '70px' }}>
			<AddEpisode />
		</div>
	);
};

export default Episode;
